// Check if string contains uppercase letters (indicating camelCase)
export function isCamelCased(str: string): boolean {
  return /[A-Z]/.test(str);
}

// Check if string contains hyphens (indicating dasherized)
export function isDasherized(str: string): boolean {
  return str.includes('-');
}
